import React, { useEffect, useRef } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { bind } from 'bind-event-listener';

export const ElementEventListener = ({
	onFocus,
	onMouseEnter,
	onRightClick,
	children,
}: {
	children: React.ReactNode;
	onFocus?: () => void;
	onMouseEnter?: () => void;
	onRightClick?: () => void;
}): React.JSX.Element => {
	const wrapperRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!wrapperRef.current || !onRightClick) {
			return;
		}

		const handleMouseDown = (e: MouseEvent) => {
			const isLink = (e.target as Element).closest('a');
			if (isLink && e.button !== 0) {
				onRightClick();
			}
		};

		const unbind = bind(wrapperRef.current, {
			type: 'mousedown',
			listener: handleMouseDown,
		});

		return unbind;
	}, [onRightClick]);

	return (
		<span ref={wrapperRef} onMouseEnter={onMouseEnter} onFocus={onFocus}>
			{children}
		</span>
	);
};
